// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tools-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.tool-card {
  background: var(--white);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.tool-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.tool-icon {
  width: 80px;
  height: 80px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  margin: 0 auto 1.5rem;
}

.tool-card h3 {
  font-size: 1.25rem;
  color: var(--dark-gray);
  margin-bottom: 0.5rem;
}

.tool-card p {
  color: var(--medium-gray);
  font-size: 0.95rem;
}

.tool-content {
  background: var(--white);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  margin-top: 2rem;
}

.tool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--light-gray);
}

.tool-header h2 {
  font-size: 1.75rem;
  color: var(--dark-gray);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.calculator {
  max-width: 400px;
  margin: 0 auto;
}

.calc-input {
  width: 100%;
  padding: 1rem;
  font-size: 1.5rem;
  text-align: right;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.calc-result {
  padding: 1rem;
  font-size: 2rem;
  font-weight: 700;
  text-align: right;
  background: var(--background);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  min-height: 60px;
  color: var(--primary-blue);
}

.calc-buttons {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
}

.calc-btn {
  padding: 1.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  background: var(--light-gray);
  color: var(--dark-gray);
  cursor: pointer;
  transition: all 0.3s ease;
}

.calc-btn:hover {
  background: var(--primary-blue);
  color: var(--white);
  transform: scale(1.05);
}

.calc-btn-equals {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: var(--white);
}

.calc-btn-clear {
  grid-column: span 3;
  background: #ef4444;
  color: var(--white);
}

.converter {
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
}

.converter-row {
  display: flex;
  gap: 1rem;
  width: 100%;
}

.converter-input {
  flex: 1 1;
  padding: 1rem;
  font-size: 1.25rem;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
}

.converter-select {
  padding: 1rem;
  font-size: 1.25rem;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
  background: var(--white);
  cursor: pointer;
}

.converter-arrow {
  font-size: 2rem;
  color: var(--primary-blue);
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.qr-generator {
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.qr-input {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
  resize: vertical;
}

.qr-preview {
  background: var(--background);
  border-radius: 1rem;
  padding: 3rem;
  text-align: center;
}

.qr-placeholder {
  color: var(--medium-gray);
}

.qr-placeholder svg {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.tool-placeholder {
  padding: 4rem;
  text-align: center;
  color: var(--medium-gray);
  font-size: 1.25rem;
  background: var(--background);
  border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Tools.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":[".tools-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.tools-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.tool-card {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.tool-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.tool-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.5rem;\n  margin: 0 auto 1.5rem;\n}\n\n.tool-card h3 {\n  font-size: 1.25rem;\n  color: var(--dark-gray);\n  margin-bottom: 0.5rem;\n}\n\n.tool-card p {\n  color: var(--medium-gray);\n  font-size: 0.95rem;\n}\n\n.tool-content {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  margin-top: 2rem;\n}\n\n.tool-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--light-gray);\n}\n\n.tool-header h2 {\n  font-size: 1.75rem;\n  color: var(--dark-gray);\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.calculator {\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.calc-input {\n  width: 100%;\n  padding: 1rem;\n  font-size: 1.5rem;\n  text-align: right;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.calc-result {\n  padding: 1rem;\n  font-size: 2rem;\n  font-weight: 700;\n  text-align: right;\n  background: var(--background);\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  min-height: 60px;\n  color: var(--primary-blue);\n}\n\n.calc-buttons {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.5rem;\n}\n\n.calc-btn {\n  padding: 1.5rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 0.5rem;\n  background: var(--light-gray);\n  color: var(--dark-gray);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.calc-btn:hover {\n  background: var(--primary-blue);\n  color: var(--white);\n  transform: scale(1.05);\n}\n\n.calc-btn-equals {\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n  color: var(--white);\n}\n\n.calc-btn-clear {\n  grid-column: span 3;\n  background: #ef4444;\n  color: var(--white);\n}\n\n.converter {\n  max-width: 500px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.converter-row {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n}\n\n.converter-input {\n  flex: 1;\n  padding: 1rem;\n  font-size: 1.25rem;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n}\n\n.converter-select {\n  padding: 1rem;\n  font-size: 1.25rem;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n  background: var(--white);\n  cursor: pointer;\n}\n\n.converter-arrow {\n  font-size: 2rem;\n  color: var(--primary-blue);\n  animation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.qr-generator {\n  max-width: 500px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.qr-input {\n  width: 100%;\n  padding: 1rem;\n  font-size: 1rem;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n  resize: vertical;\n}\n\n.qr-preview {\n  background: var(--background);\n  border-radius: 1rem;\n  padding: 3rem;\n  text-align: center;\n}\n\n.qr-placeholder {\n  color: var(--medium-gray);\n}\n\n.qr-placeholder svg {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.tool-placeholder {\n  padding: 4rem;\n  text-align: center;\n  color: var(--medium-gray);\n  font-size: 1.25rem;\n  background: var(--background);\n  border-radius: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
